module.exports = __webpack_public_path__ + "img/cladify_logo_lg.5bafe707.png";